
export default {
  name: 'VsPaginationJumper',
  inject: ['pagination', '$t'],
  watch: {
    'pagination.currentPage': {
      immediate: true,
      handler(value) {
        if (value != this.value) {
          this.value = value
        }
      }
    }
  },
  data() {
    return {
      value: 1
    }
  },
  methods: {
    onKeyup() {
      const value = parseInt(this.value)
      this.pagination.updatePage(value)
    }
  }
}
